import type { World } from './World';

/**
 * Base class for all systems
 * Systems contain logic and operate on entities with specific components
 */
export abstract class System {
  protected world!: World;
  public enabled = true;
  public readonly priority: number;

  constructor(priority = 0) {
    this.priority = priority;
  }

  /**
   * Called when system is added to the world
   */
  init(world: World): void {
    this.world = world;
  }

  /**
   * Called every fixed update (60Hz)
   */
  abstract update(deltaTime: number): void;

  /**
   * Optional render callback (called every frame)
   */
  render(_interpolation: number): void {
    // Override if needed
  }

  /**
   * Called when system is removed
   */
  dispose(): void {
    // Override if cleanup needed
  }
}
